import React from 'react';
import { BookOpenIcon, ListChecksIcon, MapIcon, SearchIcon, TableIcon, CheckSquareIcon, ClipboardListIcon, SmartphoneIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { insideItems } from '../../data/content';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  book: BookOpenIcon,
  list: ListChecksIcon,
  map: MapIcon,
  search: SearchIcon,
  table: TableIcon,
  check: CheckSquareIcon,
  clipboard: ClipboardListIcon,
  device: SmartphoneIcon
};
export function Inside() {
  return <Section dark data-id="element-208" data-mp="1d3df7wx5zu8y">
      <Eyebrow data-id="element-209" data-mp="1hw6jkjoq10ki">Get instant access</Eyebrow>
      <Heading data-id="element-210" data-mp="1hx837cjsyvdu">Inside your digital decision system</Heading>
      <p className="mt-4 text-center text-[15px] text-zinc-400" data-id="element-211" data-mp="kh2emm9k5tc5">
        What will you receive immediately?
      </p>

      <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-212" data-mp="pf3wx4z5tomk">
        {insideItems.map(item => {
        const Icon = icons[item.icon];
        return <li key={item.title} className="flex flex-col rounded-xl border border-ink-500 bg-ink-700 p-4" data-id="element-213" data-mp="zwpne6fku1cj">
              <Icon className="h-6 w-6 text-flame-400" aria-hidden="true" data-id="element-214" data-mp="r1i1r40023bt" />
              <h3 className="mt-3 font-display text-lg font-extrabold uppercase leading-tight tracking-wide text-white" data-id="element-215" data-mp="m3giahynw1zt">
                {item.title}
              </h3>
              <p className="mt-1.5 text-[14px] leading-snug text-zinc-400" data-id="element-216" data-mp="h20zkwjyi7kl">{item.body}</p>
            </li>;
      })}
      </ul>

      <figure className="mt-10" data-id="element-217" data-mp="82xddjphtc1v">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/7d531d57-5c9b-4970-b90d-d574e874f5dc.jpg" alt="Close-up of a weld bead on steel next to a phone showing the Weld Decision System" className="w-full rounded-2xl border border-ink-500" width={1200} height={900} loading="lazy" data-id="element-218" data-mp="848ipnyl6rv3" />
        <figcaption className="mt-5 text-center font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-219" data-mp="2gmgrbesfvs7q">
          Your welding decision system is always with you
        </figcaption>
      </figure>

      <p className="mt-4 text-center text-[15px] leading-relaxed text-zinc-300" data-id="element-220" data-mp="27nljxzdnsc2u">
        Instead of watching another 20-minute video every time something looks wrong, open the
        corresponding decision map, identify what you’re seeing and follow the next step.
      </p>

      <p className="mt-6 text-center font-display text-xl font-extrabold uppercase leading-tight text-spark sm:text-2xl" data-id="element-221" data-mp="34cumhe6bm76j">
        One system. Six master volumes. Hundreds of practical decisions.
      </p>

      <div className="mt-8" data-id="element-222" data-mp="2vatqslqqjt6z">
        <CTAButton sub="" data-id="element-223" data-mp="2va1uf8pbdrfn" />
      </div>
      <div className="mt-6" data-id="element-224" data-mp="1exwixm0y8c18">
        <Countdown data-id="element-225" data-mp="1ewlf5m7i74a4" />
      </div>
      <p className="mt-4 text-center text-[11px] font-semibold uppercase tracking-[0.14em] text-zinc-500" data-id="element-226" data-mp="1ewbpjzqdez4y">
        One-time payment · Instant access · Lifetime access · 7-day guarantee
      </p>
    </Section>;
}